import React, { useEffect, useState } from "react";
import { ListType, NewScheduleListType } from "src/helpers/Enums";
import apiService from "src/services/api.service";
import ListBox from "./ListBox";
import ChooseDay from "./ChooseDay";

const NewSchedule = (props) => {
  const [type, setType] = useState(NewScheduleListType.SMS);
  const [lists, setLists] = useState([]);
  const [filteredLists, setFilteredLists] = useState([]);
  const [openChooseDay, setOpenChooseDay] = useState(props.openChooseDay);
  const [chosenLists, setChosenLists] = useState(
    props.chosenLists ? props.chosenLists : []
  );
  const [search, setSearch] = useState();

  useEffect(() => {
    apiService.getAllLists().then((response) => {
      setLists(response.data);
    });
  }, []);

  useEffect(() => {
    switch (type) {
      case NewScheduleListType.SMS:
        setFilteredLists(
          lists?.filter((list) => {
            if (list.type !== ListType.SMS) return false;
            if (!search) return true;
            const listName = list?.name?.toLowerCase?.() || "";
            const searchTerm = search.toLowerCase?.() || "";

            return listName.includes(searchTerm);
          }) || []
        );
        break;
      case NewScheduleListType.Email:
        setFilteredLists(
          lists?.filter((list) => {
            if (list.type !== ListType.Email) return false;
            if (!search) return true;
            const listName = list?.name?.toLowerCase?.() || "";
            const searchTerm = search.toLowerCase?.() || "";

            return listName.includes(searchTerm);
          }) || []
        );
        break;
    }
  }, [search, type, lists]);

  const handleType = (listType) => {
    setChosenLists([]);
    setType(listType);
  };

  const handleChooseList = (item) => {
    setChosenLists(
      chosenLists?.find((list) => list._id === item._id)
        ? chosenLists.filter((list) => list._id !== item._id)
        : [...chosenLists, item]
    );
  };

  const deleteList = (list) => {
    setChosenLists(chosenLists?.filter((item) => item._id !== list._id));
  };

  const handleBack = () => {
    setOpenChooseDay(false);
  };

  const handleNext = () => {
    setOpenChooseDay(true);
  };

  return (
    <div className="NewStrategyModalOverlay">
      {openChooseDay ? (
        <ChooseDay
          chosenLists={chosenLists}
          close={props.close}
          setIsUpdate={props.setIsUpdate}
          handleBack={handleBack}
          startDate={props.startDate}
          deleteList={deleteList}
          creativeType={type === NewScheduleListType.SMS ? "SMS" : "Email"}
        ></ChooseDay>
      ) : (
        <div className="NewScheduleModal">
          <div className={"w-full flex justify-between"}>
            <div className={"NewStrategy"}>
              <img
                alt={"Logo"}
                src={"/media/icons/purplePlusIcon.svg"}
                className={"w-[18px] h-[18px]"}
              />
              New Schedule
            </div>
            <button className={"CloseIconButton"} onClick={props.close}>
              <img
                alt={"Logo"}
                src={"/media/icons/closeIcon.svg"}
                className={"w-5 h-5"}
              />
            </button>
          </div>
          <div className={"flex flex-col gap-4 w-full"}>
            <div className={"HorizontalDivider"}></div>
            <div className={"NewScheduleDescription"}>
              Please select the list you want to schedule.
            </div>
            <div className={"NewListTypeButtons"}>
              <button
                onClick={() => handleType(NewScheduleListType.SMS)}
                className={
                  type === NewScheduleListType.SMS
                    ? "NewListChosenButton"
                    : "NewListButton"
                }
              >
                {NewScheduleListType.SMS}
                {type === NewScheduleListType.SMS && (
                  <span className={"ChosenMarkerListType"}></span>
                )}
              </button>
              <img
                alt={"Logo"}
                src={"/media/icons/separate.png"}
                className={"h-[22px] w-[1px]"}
              />
              <button
                onClick={() => handleType(NewScheduleListType.Email)}
                className={
                  type === NewScheduleListType.Email
                    ? "NewListChosenButton"
                    : "NewListButton"
                }
              >
                {NewScheduleListType.Email}
                {type === NewScheduleListType.Email && (
                  <span className={"ChosenMarkerListType"}></span>
                )}
              </button>
            </div>
            <div className="relative flex items-center w-full">
              <span className="absolute left-3">
                <img
                  alt={"Logo"}
                  src={"/media/icons/searchIcon.svg"}
                  className={"h-[17px] w-[17px]"}
                />
              </span>
              <input
                type="text"
                placeholder="Search"
                className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg outline-none w-full h-9 text-[12px]"
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div
              className={"flex flex-col gap-2 max-h-[430px] overflow-y-scroll"}
            >
              {filteredLists?.map((list) => (
                <div>
                  <ListBox
                    list={list}
                    chosenLists={chosenLists}
                    handleChooseList={() => handleChooseList(list)}
                  ></ListBox>
                  <div className={"HorizontalDivider"}></div>
                </div>
              ))}
            </div>
          </div>
          <div className="flex justify-end w-full gap-3">
            <button type="button" onClick={props.close} className="CloseButton">
              Close
            </button>
            <button type="button" onClick={handleNext} className="CreateButton">
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewSchedule;
